'use strict';

var _cartTable = require('../components/cart-table');

var _cartTable2 = _interopRequireDefault(_cartTable);

var _giftCard = require('../components/gift-card');

var _giftCard2 = _interopRequireDefault(_giftCard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * DOM selectors.
 */
/**
 * Template: Cart
 * ------------------------------------------------------------------------------
 * Loosely coupled cart page scripts.
 *
 * @namespace cart
 */
var selectors = {
  container: '[js-cart="container"]',
  table: '[js-cart-table="container"]'
};

/**
 * Global instance strings.
 */
var strings = {
  title: theme.strings.cart.general.title,
  empty: theme.strings.cart.general.empty,
  continueBrowsing: theme.strings.cart.general.continue_browsing
};

document.addEventListener('DOMContentLoaded', function () {
  (0, _cartTable2.default)(selectors.table).init();
  (0, _giftCard2.default)().init();

  Frame.EventBus.listen('AjaxCart:cartEmpty', function () {
    document.querySelector(selectors.container).innerHTML = '\n      <div class="container">\n        <div class="row">\n          <div class="col s12 m6 offset-m3 text-center">\n            <h1>' + strings.title + '</h1>\n            <p>' + strings.empty + '</p>\n            <a href="/collections/all" class="button button--primary button--large">' + strings.continueBrowsing + '</a>\n          </div>\n        </div>\n      </div>\n    ';
  });
});